import { Anchor } from "@svea/design-system-components-react";
import { Accordion, P, Stack, useText } from "@sveabank/cc-common";
import { Link } from "react-router";
import { Images } from "../../../../images";

const MerOmForetagarna = () => {
	const [t, texts] = useText();
	const packages = texts.newCompany.packages;
	const text = packages["FÖRETAGARNA-SVEA-STARTA-BOLAG"];

	return (
		<Accordion>
			<Stack gap={4}>
				<Accordion.Heading fullWidth={false}>
					<P bold>{t(text.aboutHeading)}</P>
				</Accordion.Heading>
				<Accordion.Content speed="fast">
					<Stack gap={4}>
						<P className="text-sm">{t(text.aboutDescription)}</P>
						<P className="text-sm">{t(text.memberBenefitsIntro)}</P>

						<ul className="list-disc pl-8">
							<li>
								<P className="text-sm">{t(text.memberBenefit1)}</P>
							</li>
							<li>
								<P className="text-sm">{t(text.memberBenefit2)}</P>
							</li>
							<li>
								<P className="text-sm">{t(text.memberBenefit3)}</P>
							</li>
							<li>
								<P className="text-sm">{t(text.memberBenefit4)}</P>
							</li>
							<li>
								<P className="text-sm">{t(text.memberBenefit5)}</P>
							</li>
						</ul>

						<Anchor as={Link} to={t(text.externalLink)} target="_blank" iconEnd="externalLink">
							{t(text.membershipLinkText)}
						</Anchor>
					</Stack>
				</Accordion.Content>
			</Stack>
		</Accordion>
	);
};

const ClcForetagarnaInfoBlock = () => {
	const [t, texts] = useText();

	const packages = texts.newCompany.packages;
	const text = packages["FÖRETAGARNA-SVEA-STARTA-BOLAG"];

	return (
		<Stack gap={4}>
			<P bold className="text-text-headline text-base">
				{t(text.offer.membershipHeading)}
			</P>

			<div className="tablet:flex-row flex w-full flex-col gap-4">
				<div className="tablet:order-1 tablet:flex-7 order-2 w-full">
					<Stack gap={6}>
						<P className="text-sm">{t(text.offer.membershipDescription)}</P>
						<MerOmForetagarna />
					</Stack>
				</div>

				<div className="tablet:order-2 tablet:flex-3 tablet:self-start order-1 w-full">
					<div className="tablet:w-[250px] tablet:self-stretch tablet:aspect-auto aspect-2/1 shrink-0 overflow-hidden rounded-lg">
						<img
							className="tablet:scale-150 block h-full w-full scale-110 object-cover object-[60%_50%] [overflow-clip-margin:unset]"
							src={Images.FORETAGARNA_BANK_CARD_HAND}
							alt={t(text.cardImageAlt)}
						/>
					</div>
				</div>
			</div>
		</Stack>
	);
};

export default ClcForetagarnaInfoBlock;
